<template>
  <div class="content-box">
    <x-dropdown
      v-if="channels"
      v-model="query.topic_id"
      :list="channels"
      matchKey="id"
      showKey="name"
      class="x-dropdown"
    ></x-dropdown>
    <infinite-scroll
      class="scroll-box"
      :disabled="disabled"
      @to-bottom="loadMore"
      v-if="data && data.length"
    >
      <ul class="content-normal">
        <li
          @click="$router.push({name: 'coursePack', query: {id: v.id, isCustom: isCustom + ''}})"
          v-for="v of data"
          :key="v.id"
        >
          <x-image :size="49" class="cover" el="div" :img-src="v.avatar_url"/>
          <div class="content">
            <h5>{{v.name}}</h5>
            <p>{{v.description}}</p>
          </div>
        </li>
      </ul>
      <div class="scroll-tips">
        <p class="no-more" v-show="noMore">没有更多数据了</p>
        <p v-show="!noMore" class="loading">
          <loading box-size="16" round-size="4"/>加载更多...
        </p>
      </div>
    </infinite-scroll>
    <no-work-placeholder v-if="data && !data.length" tip="暂无课程包"/>
  </div>
</template>
<script>
import XImage from '@/components/XImage'
import Loading from '@/components/Loading'
import InfiniteScroll from '@/components/InfiniteScroll'
import XDropdown from '@/components/XDropdown'
import NoWorkPlaceholder from './NoWorkPlaceholder'
import { get } from '@/utils/ajax'
import mixinSearch from '@/utils/mixin_search'
const defineQuery = {
  limit: 15,
  topic_id: ''
}
export default {
  name: 'CourseList',
  components: {
    XDropdown,
    InfiniteScroll,
    Loading,
    XImage,
    NoWorkPlaceholder
  },
  mixins: [mixinSearch(defineQuery, 'replace')],
  created() {
    this.getPackageChannel()
    if (this.$route.query.topic_id) this.refresh()
  },
  data() {
    return {
      query: Object.assign({}, defineQuery),
      asyncQuery: Object.assign({}, defineQuery),
      data: null,
      page: 1,
      disabled: true,
      noMore: false,
      channels: null
    }
  },
  computed: {
    isCustom() {
      return (
        this.query.topic_id === 'custom' ||
        this.$route.query.topic_id === 'custom'
      )
    }
  },
  methods: {
    async getPackageChannel() {
      let channels = await get('/edu/wap/lesson/official/packages/topics')
      channels = channels.map(v => ({ ...v, id: v.id + '' }))
      channels.push({ id: 'custom', name: '教师上传课程包' })
      this.channels = channels
      if (!this.query.topic_id) {
        if (channels[0]) {
          this.query.topic_id = channels[0].id
        }
      }
    },
    async refresh(type = 'fresh', ext = { page: 1 }) {
      const { isCustom } = this
      this.disabled = true
      const { items } = await get(
        `/edu/wap/${isCustom ? 'upload' : 'lesson'}/packages`,
        Object.assign({}, this.$route.query, ext),
        { loading: ext.page === 1 }
      )
      const length = items.length
      if (length && type === 'more') this.data = this.data.concat(items)
      if (type === 'fresh') {
        this.data = items
        this.page = 1
      }
      if (length === 0 || length < this.query.limit) {
        this.noMore = true
      } else {
        this.disabled = false
        this.page++
      }
    },
    loadMore() {
      if (this.disabled) return
      this.refresh('more', { page: this.page })
    }
  }
}
</script>

<style lang="stylus" scoped>
.is-web
  .x-dropdown
    top 63px
.x-dropdown
  position fixed
  width 100%
  left 0
  z-index 10
.content-box
  padding-top 44px
.content-box, .scroll-box
  height 100%
.cover
  width 100px
  height 75px
  flex-shrink 0
  border-radius 8px
  margin-right 10px
.scroll-tips
  margin-top 10px
  min-height 20px
.scroll-box
  position relative
.no-more
  text-align center
.loading
  display flex
  justify-content center
  margin-right 5px
  >>> .spinner
    margin-right 10px
li
  padding-top 16px
  padding-bottom 16px
  display flex
  // border-1('%23ccc', bottom)
  border-bottom 1px solid #f6f6f6
  &:last-child
    border-bottom 0
  p
    text-ellipsis(2)
    margin-bottom 0
h5
  font-size 16px
  color #333
  margin-bottom 3px
</style>
